
export default function ({state}, val) {
    let paramsForPrint = val.Url.replace(/parameters\[/g, '').replace(/\]/g, '').replace(/ /g, '');
    paramsForPrint = paramsForPrint.substr(paramsForPrint.indexOf('?') + 1);
    let url = '/tourclient/editor/#/print/' + val.WebReportId + '?' + paramsForPrint;
    let win = window.open(url, '_blank');
    win.focus();
}